module.exports = __webpack_public_path__ + "static/media/heart2019.5a24d0df.jpg";